import Alpine from 'alpinejs';

const weglotScript = document.createElement('script');
weglotScript.src = 'https://cdn.weglot.com/weglot.min.js';
weglotScript.async = true;
document.head.appendChild(weglotScript);

// Initialize Weglot when the script is loaded
weglotScript.onload = () => {
  if (window.Weglot && typeof window.Weglot.initialize === 'function') {
    window.Weglot.initialize({
      // The Weglot docs don't seem to encourage keeping this api key private or using
      // different keys for different environments. They do encourage using CORs to limit
      // the domains where the key can be used.
      api_key: 'wg_454710915f3434db1640779c9697d5e19',
      excluded_blocks: [{ value: '.no-translate' }],
      hide_switcher: true,
      cache: true,
      auto_switch: true,
    });

    window.Weglot.on('initialized', () => {
      Alpine.data('weglot', () => ({
        languages: [],
        currentLang: null,
        selectedLang: null,
        init() {
          this.selectedLang = this.currentLang = window.Weglot.getCurrentLang();
          this.languages = [
            window.Weglot.options.language_from,
            ...window.Weglot.options.languages.map((lang) => lang.language_to),
          ];
        },
        confirm() {
          window.Weglot.switchTo(this.selectedLang);
          MicroModal.close();
        },
      }));
    });
  }
};
